/* Theme-owned prototype. The article contains only the HTML/data fragment. */
(() => {
  'use strict';
  const selector = '[data-jr-component="guest-list"]';
  const integer = (value, low, high) => {
    if (value === undefined || value.trim() === '') return null;
    const number = Number(value);
    return Number.isSafeInteger(number) && number >= low && number <= high ? number : null;
  };
  const quantity = (row, guests) => {
    if (row.rule === 'fixed') return row.units;
    if (row.rule === 'per-guest') return guests * row.units;
    return Math.ceil(guests / row.groupSize) * row.units;
  };
  function enhance(root) {
    if (root.dataset.jrEnhanced === 'true' || root.dataset.jrVersion !== '1') return;
    const initial = integer(root.dataset.jrDefault, 1, 24);
    const minimum = integer(root.dataset.jrMin, 1, 24);
    const maximum = integer(root.dataset.jrMax, 1, 24);
    if (initial === null || minimum === null || maximum === null || minimum > initial || initial > maximum) return;
    const controls = root.querySelector('[data-jr-controls]');
    const input = root.querySelector('[data-jr-input]');
    const minus = root.querySelector('[data-jr-minus]');
    const plus = root.querySelector('[data-jr-plus]');
    const current = root.querySelector('[data-jr-current]');
    const announcement = root.querySelector('[data-jr-announcement]');
    if (!controls || !input || !minus || !plus || !current || !announcement) return;
    const elements = Array.from(root.querySelectorAll('[data-jr-rule]'));
    if (!elements.length || elements.length > 40) return;
    const rows = [];
    for (const element of elements) {
      const rule = element.dataset.jrRule;
      const units = integer(element.dataset.jrUnits, 0, 1000);
      const groupSize = rule === 'per-group' ? integer(element.dataset.jrGroupSize, 1, 24) : 1;
      const output = element.querySelector('[data-jr-qty]');
      if (!['fixed', 'per-guest', 'per-group'].includes(rule) || units === null || groupSize === null || !output) return;
      const label = element.querySelector('[data-jr-one][data-jr-other]');
      if (label && (!label.dataset.jrOne.trim() || !label.dataset.jrOther.trim())) return;
      const row = { rule, units, groupSize, output, label };
      // A mismatching fallback is an authoring error; leave it static for review.
      if (Number(output.textContent.trim()) !== quantity(row, initial)) return;
      rows.push(row);
    }
    if (Number(current.textContent.trim()) !== initial) return;
    let guests = initial;
    function update(value, announce) {
      const number = value === '' ? NaN : Number(value);
      const normalized = Number.isFinite(number) ? Math.max(minimum, Math.min(maximum, Math.round(number))) : guests;
      guests = normalized;
      input.value = String(guests);
      current.textContent = String(guests);
      for (const row of rows) {
        const count = quantity(row, guests);
        row.output.textContent = String(count);
        if (row.label) row.label.textContent = count === 1 ? row.label.dataset.jrOne : row.label.dataset.jrOther;
      }
      minus.disabled = guests === minimum;
      plus.disabled = guests === maximum;
      if (announce) announcement.textContent = `Supply list updated for ${guests} children.`;
    }
    input.min = String(minimum);
    input.max = String(maximum);
    input.step = '1';
    minus.addEventListener('click', () => update(guests - 1, true));
    plus.addEventListener('click', () => update(guests + 1, true));
    input.addEventListener('change', () => update(input.value, true));
    input.addEventListener('blur', () => update(input.value, false));
    root.dataset.jrEnhanced = 'true';
    update(guests, false);
    controls.hidden = false;
  }
  function initialize(scope) {
    if (scope.matches?.(selector)) enhance(scope);
    scope.querySelectorAll?.(selector).forEach(enhance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
